import { render, staticRenderFns } from "./EditProfileGroupPage.vue?vue&type=template&id=7617e89a"
import script from "./EditProfileGroupPage.vue?vue&type=script&lang=js"
export * from "./EditProfileGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports